<div class="app-layout">
  <!-- Topbar -->
  <header class="topbar">
    <tw-topbar></tw-topbar>
  </header>

  <div class="content-wrapper">
    <aside class="sidebar">
      <tw-sidebar></tw-sidebar>
    </aside>

    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </div>

  <tw-spinner></tw-spinner>
</div>

<p-toast key="globalToast" position="bottom-right"></p-toast>
